import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=c82386d0"
import script from "./Recorder.vue?vue&type=script&lang=js"
export * from "./Recorder.vue?vue&type=script&lang=js"
import style0 from "./Recorder.vue?vue&type=style&index=0&id=c82386d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.23_vue-template-compiler@2.7.16_webpack@5.105.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports